<template>
  <div v-if="!content.hideOnWeb" :class="brandClasses.root">
    <component
      :is="getActionLinkComponent(content.target, { link: VfLink, fallback: 'span' })"
      v-if="content.title"
      :class="[
        brandClasses.title,
        presets[content.menuStyle!],
        { 'cursor-pointer bg-transparent p-0 text-left': isActionLinkOnly(content.target) },
      ]"
      v-bind="getActionLinkAttrs(content.target)"
      :variant
      @click="$emit('click')"
    >
      <span v-if="$feature.showTitleHtml" v-html="content.titleHtml" class="underscore" />
      <span v-else class="underscore">{{ content.title }}</span>
    </component>
    <ul v-if="content.children?.length" class="text-sm" :class="brandClasses.ul">
      <li v-for="menuItem in content.children.filter((item) => !item.hideOnWeb)" :key="menuItem.id">
        <cms-section
          :section="{
            name: menuItem.id,
            items: [menuItem],
          }"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { VfLink } from '#components'

export type Props = {
  content: MenuItem
}

export type Emits = {
  click: []
}

defineProps<Props>()

defineEmits<Emits>()

const { $feature } = useNuxtApp()
const { getActionLinkAttrs, getActionLinkComponent, isActionLinkOnly } = useCmsActionLink()
const { brandClasses: baseClasses, brandClassesV2, presets, variant } = useAppConfig().components.cms.megaMenuL2Desktop

const brandClasses = computed(() => ({ ...baseClasses, ...($feature.tempMegaMenuDesktopRedesign && brandClassesV2) }))
</script>
